import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import 'antd/dist/antd.less';
import './index.scss'
import App from './App';
import AppProviders from "./context";

const salestec = document.getElementById('salestec');

let customerName = salestec?.dataset.customerName;
let language = salestec?.dataset.language || 'de';

if (['de', 'en'].indexOf(language) < 0) {
    language = 'de';
}

ReactDOM.render(
    <AppProviders language={language}>
        <App customerName={customerName} />
    </AppProviders>,
    document.getElementById('salestec')
)
;
